<template>
  <div>
    <div v-if="loading" class="text-center">
      <circles-loader></circles-loader>
    </div>
    <div v-else class="pa-2">
      <v-timeline :dense="$vuetify.breakpoint.smAndDown">
        <v-timeline-item v-for="(i, index) in releases" :key="i._id">
          <template v-slot:icon>
            <v-icon color="secondary">mdi-cube-outline</v-icon>
          </template>
          <template v-slot:opposite>
            <span class="supporting-text">{{ $d(new Date(i.time), 'short', $i18n.locale) }}</span>
          </template>
          <v-expansion-panels>
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header :class="isOdd(index) && !isSmallerDisplay() ? 'text-right' : 'text-left'"
                @click="acknowledgeRelease(i)">
                <div>
                  <v-icon class="mr-1" v-if="i.isNew" color="secondary">mdi-exclamation</v-icon>
                  {{ i.version }}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <ImageDisplay width="100%" v-if="i.image" :src="i.image"></ImageDisplay>
                <v-list-item-content v-html="i.contents"></v-list-item-content>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="likeRelease(i)" :color="i.liked ? 'secondary' : ''">
                    <v-icon>mdi-thumb-up</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-timeline-item>
      </v-timeline>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";
import CirclesLoader from "@/components/displays/CirclesLoader.vue";

export default {
  data() {
    return {
      loading: true,
      releases: [],
    };
  },
  components: { CirclesLoader },
  created() {
    if (this.$store.state.managedAcademy) {
      Api()
        .get("releases/project/bjjlink-admin")
        .then((response) => {
          this.loading = false;
          this.releases = response.data.releases;
        });
    }
  },
  methods: {
    likeRelease(item) {
      const releaseId = item._id;
      Api()
        .patch("releases/like/release/" + releaseId)
        .then((response) => {
          if (response) {
            const liked = response.data.liked;
            item.liked = liked;
          }
        });
    },
    isOdd(num) { return num % 2; },
    isNew(release) {
      if (
        release.seenBy &&
        release.seenBy.indexOf(this.$store.state.user._id) >= 0
      )
        return false;
      return true;
    },
    acknowledgeRelease(r) {
      if (r.isNew) {
        Api()
          .patch("releases/acknowledge/releases", { releases: [r._id] })
          .then((response) => {
            if (response) {
              r.isNew = false;
              var currentCount = this.$store.state.releasesCount;
              currentCount--;
              this.$store.dispatch("setReleasesCount", currentCount);
            }
          });
      }
    },
  },
};
</script>

<style scoped></style>